import { createPinia } from 'pinia'
import { createApp } from 'vue'

import App from '@/App.vue'
import { i18n } from '@/i18n'
import { router } from '@/router'
import { useAuthStore } from '@/stores/auth'
import '@/style.css'

/**
 * 应用入口。
 *
 * 启动顺序是有讲究的：Pinia 必须在路由守卫真正跑起来之前装好，
 * 因为守卫要读 auth store 判断登录状态；而恢复登录态又必须在挂载之前完成，
 * 否则刷新页面时会先闪一下登录页再跳回来。
 */
const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(i18n)

// 从 localStorage 恢复上一次的登录状态。
//
// 必须在 app.use(router) 之前做完。路由守卫在首次导航时就会检查登录状态，
// 如果那时 store 还是空的，守卫会判定「未登录」并跳到登录页——
// 用户明明有有效 token，却每次刷新都被踢出去。
useAuthStore(pinia).restoreFromStorage()

app.use(router)

app.mount('#app')
